// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__28cSD","footer":"ChangeClinic_footer__1mueh"};